
import { RepositoryFactory } from './RepositoryFactory';

/**
 * Bootstrap function to initialize the application
 */
export function bootstrap() {
  // Initialize repository factory
  const repositoryFactory = RepositoryFactory.getInstance();
  
  console.log('Application bootstrapped successfully');
  
  return {
    repositoryFactory
  };
}

/**
 * Bootstrap services function
 */
export function bootstrapServices() {
  console.log('🚀 Initializing services...');
  const repositoryFactory = RepositoryFactory.getInstance();
  return { repositoryFactory };
}

/**
 * Health check function
 */
export function healthCheck() {
  try {
    const repositoryFactory = RepositoryFactory.getInstance();
    return {
      status: 'healthy' as const,
      services: {
        repositoryFactory: 'ok'
      }
    };
  } catch (error) {
    return {
      status: 'unhealthy' as const,
      services: {
        repositoryFactory: 'error'
      }
    };
  }
}
